import { defineStore } from 'pinia'

export const usePlatformStore = defineStore('platform', {
    state: () => ({
        isMobile: false,
        fileSize: 0,
    }),
    getters: {
        getIsMobile: state => state.isMobile,
        getFileSize: state => state.fileSize,
    },
    actions: {
        setIsMobile(isMobile: boolean) {
            this.isMobile = isMobile
        },
        setFileSize(fileSize: number) {
            this.fileSize = fileSize
        },
    },
})
